import http from "./http_common";

const ContactUs = {
    saveContactUsEnquiry(data) {
        return http.post("/contactEnquiry/save", data);
    }
}
    export default ContactUs;